import React from 'react';
import classNames from 'classnames';

export default function ServicesIcon({ className = '' }) {
	return <span className={classNames('icon icon-services_and_amenities', className)} />;
}
